import { Controller } from "@hotwired/stimulus"

// Infinite ticker marquee.
//
// The HAML partial already repeats brand names 8× so the content block is
// always wider than any viewport. This controller just clones that block once,
// giving us two identical halves. The CSS animation then runs from
// translateX(0) → translateX(-50%), which is exactly one block width —
// seamless loop regardless of screen size or number of brands.

export default class extends Controller {
  static targets = ["track"]
  static values  = { speed: Number }

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    const track    = this.trackTarget
    const original = track.firstElementChild
    if (!original) return

    const clone = original.cloneNode(true)
    clone.setAttribute("aria-hidden", "true")
    track.appendChild(clone)

    const duration = this.hasSpeedValue ? this.speedValue : 30
    track.style.setProperty("--marquee-duration", `${duration}s`)
  }
}
